import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import ErrorSec from '../components/sections/ErrorSec';

const Error = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.breadcrumb.error.title" subtitleKey="sections.breadcrumb.error.subtitle" />
        <ErrorSec className="space overflow-hidden" />
      <Footer />
    </>
  );
};

export default Error;